(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nous-rejoindre"] && !Shopify.designMode) return;
  try {
    
(function () {
  const btns = document.querySelectorAll('.rejoindre__accordion-btn');

  btns.forEach(btn => {
    btn.addEventListener('click', () => {
      const panelId = btn.getAttribute('aria-controls');
      const panel   = document.getElementById(panelId);
      const isOpen  = btn.getAttribute('aria-expanded') === 'true';

      // Fermer tous les autres
      btns.forEach(b => {
        const p = document.getElementById(b.getAttribute('aria-controls'));
        b.setAttribute('aria-expanded', 'false');
        p.classList.remove('open');
      });

      // Ouvrir / fermer celui cliqué
      if (!isOpen) {
        btn.setAttribute('aria-expanded', 'true');
        panel.classList.add('open');
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portfolio-gallery"] && !Shopify.designMode) return;
  try {
    

(function () {
  "use strict";

  const grid = document.getElementById('portfolio-grid');
  const filterBtns = document.querySelectorAll('.portfolio-gallery__filter-btn');
  const items = document.querySelectorAll('.portfolio-gallery__item');
  const emptyMsg = document.getElementById('portfolio-empty');
  const galleryContainer = document.getElementById('portfolio-gallery');

  let masonryInstance = null;
  let currentFilter = 'all';
  let visibleImgs = [];
  let currentIndex = 0;

  /* ── Classe Masonry ── */
  class MasonryGrid {
    constructor(container) {
      this.container = container;
      this.items = [...container.children].filter(item => !item.classList.contains('hidden'));
      this.gap = parseInt(getComputedStyle(galleryContainer).getPropertyValue('--gap')) || 6;
      this.resizeTimer = null;
      
      this.init();
      window.addEventListener('resize', () => this.handleResize());
    }

    init() {
      this.container.style.position = 'relative';
      this.container.style.height = '0';
      this.layout();
    }

    getColumnCount() {
      const width = window.innerWidth;
      const columns = parseInt(getComputedStyle(galleryContainer).getPropertyValue('--columns')) || 3;
      const mobileColumns = parseInt(getComputedStyle(galleryContainer).getPropertyValue('--columns-mobile')) || 2;
      
      if (width <= 768) return mobileColumns;
      return columns;
    }

    updateItems() {
      this.items = [...this.container.children].filter(item => !item.classList.contains('hidden'));
    }

    layout() {
      this.updateItems();
      
      if (this.items.length === 0) {
        this.container.style.height = '0';
        return;
      }

      const colCount = this.getColumnCount();
      const containerWidth = this.container.offsetWidth;
      const colWidth = (containerWidth - (this.gap * (colCount - 1))) / colCount;
      
      // Tableau pour suivre la hauteur de chaque colonne
      const colHeights = new Array(colCount).fill(0);
      
      // Forcer le navigateur à calculer les dimensions
      this.items.forEach(item => {
        item.style.width = `${colWidth}px`;
        item.offsetHeight; // Force reflow
      });
      
      // Positionner chaque item
      this.items.forEach(item => {
        // Trouver la colonne la plus courte
        const shortestCol = colHeights.indexOf(Math.min(...colHeights));
        
        // Calculer la position
        const left = shortestCol * (colWidth + this.gap);
        const top = colHeights[shortestCol];
        
        // Appliquer la position
        item.style.transform = `translate(${left}px, ${top}px)`;
        
        // Mettre à jour la hauteur de la colonne
        colHeights[shortestCol] += item.offsetHeight + this.gap;
      });
      
      // Ajuster la hauteur du container
      this.container.style.height = `${Math.max(...colHeights) - this.gap}px`;
    }

    handleResize() {
      clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => this.layout(), 100);
    }

    destroy() {
      window.removeEventListener('resize', this.handleResize);
      this.items.forEach(item => {
        item.style.transform = '';
        item.style.width = '';
      });
      this.container.style.height = '';
    }
  }

  /* ── Initialisation du masonry ── */
function initMasonry() {
  if (masonryInstance) {
    masonryInstance.destroy();
  }
  masonryInstance = new MasonryGrid(grid);
  grid.classList.add('is-ready');
  galleryContainer.classList.add('is-ready');

  }

  /* ── Attendre le chargement des images ── */
  function waitForImages() {
    const images = grid.querySelectorAll('img');
    let loadedCount = 0;
    const totalImages = images.length;
    
    if (totalImages === 0) {
      initMasonry();
      return;
    }
    
    images.forEach(img => {
      if (img.complete) {
        loadedCount++;
        if (loadedCount === totalImages) initMasonry();
      } else {
        img.addEventListener('load', () => {
          loadedCount++;
          if (loadedCount === totalImages) initMasonry();
        });
        img.addEventListener('error', () => {
          loadedCount++;
          if (loadedCount === totalImages) initMasonry();
        });
      }
    });
  }

  /* ── Filtres ── */
  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      const target = btn.dataset.collection;
      let visible = 0;

      items.forEach(item => {
        const match = target === 'all' || item.dataset.collection === target;
        item.classList.toggle('hidden', !match);
        if (match) visible++;
      });

      emptyMsg.style.display = visible === 0 ? 'block' : 'none';
      currentFilter = target;
      
      // Recalculer le masonry après filtrage
      setTimeout(() => {
        if (masonryInstance) {
          masonryInstance.updateItems();
          masonryInstance.layout();
        }
        buildVisibleList();
      }, 350); // Attendre la fin de la transition CSS
    });
  });

  /* ── Lightbox ── */
  const dialog = document.getElementById('portfolio-lightbox');
  const lbImg = document.getElementById('lightbox-img');
  const lbClose = document.getElementById('lightbox-close');
  const lbPrev = document.getElementById('lightbox-prev');
  const lbNext = document.getElementById('lightbox-next');

  function buildVisibleList() {
    visibleImgs = Array.from(items)
      .filter(item => !item.classList.contains('hidden'))
      .map(item => {
        const img = item.querySelector('img');
        return { src: img.src, alt: img.alt, element: item };
      });
  }

  function openLightbox(index) {
    if (visibleImgs.length === 0) return;
    
    currentIndex = index;
    const data = visibleImgs[currentIndex];
    lbImg.src = data.src.replace('width=600', 'width=1400');
    lbImg.alt = data.alt;
    dialog.showModal();
    updateNav();
  }

  function closeLightbox() {
    dialog.close();
  }

  function updateNav() {
    if (lbPrev) lbPrev.style.display = currentIndex > 0 ? 'flex' : 'none';
    if (lbNext) lbNext.style.display = currentIndex < visibleImgs.length - 1 ? 'flex' : 'none';
  }

  function showPrev() {
    if (currentIndex > 0) openLightbox(currentIndex - 1);
  }

  function showNext() {
    if (currentIndex < visibleImgs.length - 1) openLightbox(currentIndex + 1);
  }

  items.forEach((item) => {
    const inner = item.querySelector('.portfolio-gallery__item-inner');
    if (inner) {
      inner.addEventListener('click', (e) => {
        e.preventDefault();
        buildVisibleList();
        const img = item.querySelector('img');
        const idx = visibleImgs.findIndex(v => v.src === img.src);
        if (idx !== -1) openLightbox(idx);
      });
    }
  });

  if (lbClose) lbClose.addEventListener('click', closeLightbox);
  if (lbPrev) lbPrev.addEventListener('click', showPrev);
  if (lbNext) lbNext.addEventListener('click', showNext);

  document.addEventListener('keydown', (e) => {
    if (!dialog.open) return;
    if (e.key === 'ArrowLeft') showPrev();
    if (e.key === 'ArrowRight') showNext();
  });

  dialog.addEventListener('click', (e) => {
    if (e.target.closest('.portfolio-lightbox__nav, .portfolio-lightbox__close, .portfolio-lightbox__img-wrap')) return;
    closeLightbox();
  });

  /* ── Initialisation ── */
  buildVisibleList();
  
  // Attendre que tout soit chargé
  if (document.readyState === 'complete') {
    waitForImages();
  } else {
    window.addEventListener('load', waitForImages);
  }

  // Recalculer au redimensionnement
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      if (masonryInstance) masonryInstance.layout();
    }, 150);
  });

})();


  } catch(e) { console.error(e); }
})();
})();
